import { ModelBase } from 'store/model-base';

export class LineItemPlan extends ModelBase {
    public static storeName: string = 'lineItemPlan';

    public planCode: string;
    public planName: string;
    public dataIncluded: number;
    public dataUnlimited: boolean;
    public pricePerCycle: number;
    public pricePerData: number;
    public throttleLimit: number;

    public get isByTheGig(): boolean {
        return this.dataUnlimited !== undefined && !this.dataUnlimited;
    }

    public get isUnlimited(): boolean {
        return this.dataUnlimited;
    }

    public get hasSharedData(): boolean {
        return Boolean(this.isByTheGig && this.dataIncluded);
    }
}
